export default {
  brewery: 'HorusSkyGod',
  info_url: 'http://landing.tavour.com/HorusSkyGod/',
  title: {
    in_progress: '',
    success: 'You Joined Horus Aged Ales Sky God Club! ',
    subtext: 'Join Horus Aged Ales Sky God Club. ',
    sub_subtext: 'This 12-bottle membership focuses on barrel aged releases. ' +
      'Six unique skus shipped in June for $680 (includes shipping).',
  },
  review: {
    summary: [
      'You are joining Horus Aged Ales Sky God Club. ',
      'By signing up your card will be charged $680 per release (shipping included). ' +
      'Each June, we\'ll send you a total of 12 bottles, 6 different barrel aged releases. ' +
      'You will have the option to opt out by emailing support@tavour.com. ' +
      'You will receive a notification when your box has been charged and shipped. ',
    ],
    button_text: 'Join the Sky God Club!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/horusSkyGod.js